import NotificationSettingsForm from "@/components/settings/NotificationSettingsForm";
import { createFileRoute } from "@tanstack/react-router";
import { DeleteAccount } from "@/features/settings/components/DeleteAccount";
import { TwoFactorSettingsCard } from "@/features/mfa/TwoFactorSettingsCard";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export const Route = createFileRoute("/_provider/provider/settings/")({
  component: SettingsPage,
});

function SettingsPage() {
  return (
    <div className="p-2 pt-4 md:pt-8 md:p-8 flex justify-center">
      <div className="space-y-8 max-w-3xl w-full">
        <h1 className="text-2xl font-bold mb-6 text-center">
          Account Settings
        </h1>
        <NotificationSettingsForm />
        <TwoFactorSettingsCard />
        <Card className="border-destructive/20">
          <CardHeader>
            <CardTitle className="text-destructive">Delete Account</CardTitle>
            <CardDescription>Permanently delete your account</CardDescription>
          </CardHeader>
          <CardContent>
            <DeleteAccount />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
